import { render, staticRenderFns } from "./GStudentFilter.vue?vue&type=template&id=cb7fbc0a&scoped=true&"
import script from "./GStudentFilter.vue?vue&type=script&lang=ts&"
export * from "./GStudentFilter.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentFilter.vue?vue&type=style&index=0&id=cb7fbc0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7fbc0a",
  null
  
)

export default component.exports